module.exports = __webpack_public_path__ + "img/ref-object@2x.39a56570.png";